import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrecheckinStep1Repository } from '@/core/domain/precheckin/repository/precheckin-step1.repository';
import { PrecheckinImplRepository } from './precheckin-impl.repository';
import { SavePrecheckinUseCase } from '@/core/domain/precheckin/usecases/save-precheckin.usecase';
import { ClearPrecheckinUseCase } from '@/core/domain/precheckin/usecases/clear-precheckin.usecase';
import { GetPrecheckinUseCase } from '@/core/domain/precheckin/usecases/get-precheckin.usecase';
import { SendChangeHourUseCase } from '@/core/domain/precheckin/usecases/send-change-hour.usecase';
import { UpdatePrecheckinUseCase } from '@/core/domain/precheckin/usecases/updatePrecheckin.usecase';

const savePrecheckinUseCaseFactory = (
    precheckinRepository: PrecheckinStep1Repository,
) => new SavePrecheckinUseCase(precheckinRepository);

const clearPrecheckinUseCaseFactory = (
    reservationRepository: PrecheckinStep1Repository,
) => new ClearPrecheckinUseCase(reservationRepository);

const getPrecheckinUseCaseFactory = (
    reservationRepository: PrecheckinStep1Repository,
) => new GetPrecheckinUseCase(reservationRepository);

const updatePrecheckinUseCaseFactory = (
    reservationRepository: PrecheckinStep1Repository,
) => new UpdatePrecheckinUseCase(reservationRepository);

const sendChangeHourUseCaseFactory = (
    reservationRepository: PrecheckinStep1Repository,
) => new SendChangeHourUseCase(reservationRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: SendChangeHourUseCase,
            useFactory: sendChangeHourUseCaseFactory,
            deps: [PrecheckinStep1Repository],
        },
        {
            provide: GetPrecheckinUseCase,
            useFactory: getPrecheckinUseCaseFactory,
            deps: [PrecheckinStep1Repository],
        },
        {
            provide: UpdatePrecheckinUseCase,
            useFactory: updatePrecheckinUseCaseFactory,
            deps: [PrecheckinStep1Repository],
        },
        {
            provide: SavePrecheckinUseCase,
            useFactory: savePrecheckinUseCaseFactory,
            deps: [PrecheckinStep1Repository],
        },
        {
            provide: PrecheckinStep1Repository,
            useClass: PrecheckinImplRepository,
        },
        {
            provide: ClearPrecheckinUseCase,
            useFactory: clearPrecheckinUseCaseFactory,
            deps: [PrecheckinStep1Repository],
        },
    ],
})
export class PrecheckinDataModule {}
